import { Controller } from "@hotwired/stimulus";
import { initializeTooltips } from "../../../../../../scripts/tooltips";

export default class DestinationPagedListController extends Controller {
    connect() {
        initializeTooltips($(this.element));
    }
}